var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5123.638,1634.639a1.473,1.473,0,0,0-2.087,0l-9.981,9.978-9.975-9.978a1.476,1.476,0,0,0-2.089,2.087l9.975,9.981-9.977,9.975a1.479,1.479,0,0,0,0,2.09,1.472,1.472,0,0,0,2.087,0l9.979-9.978,9.981,9.978a1.477,1.477,0,0,0,2.087-2.09l-9.979-9.975,9.979-9.981A1.472,1.472,0,0,0,5123.638,1634.639Z",
    transform: "translate(-5099.072 -1634.206)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.b5d9c3eb717d9712bd528f89c05ee1dd.svg";
export { ForwardRef as ReactComponent };